module.exports = __webpack_public_path__ + "img/company.7ace8cea.png";